module.exports = __webpack_public_path__ + "img/img_map.07f906ec.png";